var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLabelPrinting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-labelPrinting"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-labelPrinting",
    clipPath: "url(#clip-icon-labelPrinting)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.13 0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 24,
    height: 165.13,
    rx: 8,
    transform: "translate(367.121 690.815)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 24,
    height: 165.13,
    rx: 8,
    transform: "translate(501.834 690.815)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 64,
    height: 165.13,
    rx: 8,
    transform: "translate(414.477 690.815)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 24,
    height: 165.13,
    rx: 8,
    transform: "translate(684.599 690.815)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 24,
    height: 165.13,
    rx: 8,
    transform: "translate(549.886 690.815)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 64,
    height: 165.13,
    rx: 8,
    transform: "translate(597.243 690.815)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M840.13,388.832H239.87a100.113,100.113,0,0,0-100,100v220a32.03,32.03,0,0,0,32,32h58.06a8.006,8.006,0,0,1,7.96,7.18v133a60.073,60.073,0,0,0,60,60H782.11a60.073,60.073,0,0,0,60-60V747.552a8.012,8.012,0,0,1,7.9-6.72h58.12a32.036,32.036,0,0,0,32-32v-220A100.113,100.113,0,0,0,840.13,388.832Zm-54.02,488.18a8,8,0,0,1-8,8H299.87a8.022,8.022,0,0,1-5.98-5.84V650.832a8,8,0,0,1,8-8H778.11a8,8,0,0,1,8,8Zm98.02-200.18a8,8,0,0,1-8,8H850a7.991,7.991,0,0,1-7.89-6.67v-31.33a60.073,60.073,0,0,0-60-60H297.89a60.073,60.073,0,0,0-60,60v30.82a8.006,8.006,0,0,1-7.96,7.18H203.87a8,8,0,0,1-8-8v-188a44.052,44.052,0,0,1,44-44H840.13a44.052,44.052,0,0,1,44,44Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M819.486,359.51h-24a16,16,0,0,1-16-16V276.443a16,16,0,0,0-4.475-11.1l-63.03-65.455a16,16,0,0,0-11.526-4.9H312.234a16,16,0,0,0-16,16V343.51a16,16,0,0,1-16,16h-24a16,16,0,0,1-16-16V210.988a72,72,0,0,1,72-72H700.455a72,72,0,0,1,51.863,22.058l78.693,81.72a16,16,0,0,1,4.475,11.1V343.51A16,16,0,0,1,819.486,359.51Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLabelPrinting);
export default __webpack_public_path__ + "static/media/icon-labelPrinting.cb642312a8285c767e60afac8d9339fc.svg";
export { ForwardRef as ReactComponent };